export default {
    getPatientEvidenceNonValidatedDocumentsDataTableOptions: state => state.patientEvidenceNonValidatedDocumentsDataTableOptions,
    getPatientEvidenceNonValidatedDocumentsRowActions: state => state.patientEvidenceNonValidatedDocumentsRowActions,
    getPatientEvidenceNonValidatedDocumentsActions: state => state.patientEvidenceNonValidatedDocumentsActions,
    getPatientEvidenceNonValidatedDocumentsHeaderFields: state => state.patientEvidenceNonValidatedDocumentsHeaderFields,
}
